import { rule as zhRule } from '../zh-CN/rule'

export const rule = {
  ...zhRule,
  applyRule: {
    ...zhRule.applyRule,
    title: 'Registration Rules',
    descTitle: 'The competition is open to eligible university students in China and overseas.',
    list: [
      { text: 'All team members must be full-time students enrolled at an eligible university or research institution. Undergraduate, master\'s and doctoral students of all majors and years may participate.' },
      { text: 'Teams must consist of 2–5 members. Cross-year, cross-major and cross-university teams are permitted, subject to the eligibility requirements of the selected track.' },
      { text: 'Registration information must be complete, accurate and valid. Each person may join only one team across all competition tracks.' },
      { text: 'Teams must independently complete their work and comply with applicable laws. Cheating, fraud, plagiarism and infringement of third-party intellectual property are prohibited.' },
      { text: 'Participants retain the intellectual property rights to their work. Organisers may use submitted work and team information for non-commercial competition publicity, authorised media, exhibitions and official publications.' },
      { text: 'No registration fee is charged. Arrangements for invited finalists will be communicated separately by the Organising Committee.' }
    ],
    group: {
      ...zhRule.applyRule.group,
      email: {
        list: [
          { emailText: 'Artificial Intelligence Track: fintechathon@g-ican.com' },
          { emailText: 'Data Analytics Track: clubear@clubear.org' }
        ]
      }
    }
  },
  reviewRule: {
    title: 'Judging Criteria',
    main: [
      {
        type: 'ai',
        titleImg: '',
        title: 'Artificial Intelligence Track',
        titleMobile: 'AI',
        titleColor: '#E1574D',
        titleBgColor: '253, 218, 216',
        list: [
          { percent: '40%', title: 'Completeness of Implementation' },
          { percent: '30%', title: 'Innovation' },
          { percent: '30%', title: 'Business Value' }
        ]
      },
      {
        type: 'blockchain',
        titleImg: '',
        title: 'Data Analytics Track',
        titleMobile: 'Data',
        titleColor: '#7550E1',
        titleBgColor: '235, 227, 255',
        list: [
          { percent: '30%', title: 'Data Modelling & Interpretation' },
          { percent: '20%', title: 'Data Description' },
          { percent: '20%', title: 'Research Context' },
          { percent: '20%', title: 'Commercial Application' },
          { percent: '10%', title: 'AI Innovation' }
        ]
      }
    ]
  },
  notice: {
    title: 'Competition Statement',
    list: [
      { id: '01', text: 'To protect fairness and participant rights, all entrants must read, confirm and comply with the rules published on the official website.' },
      { id: '02', text: 'Competition arrangements may be updated when necessary. The latest version published on the official website shall prevail.' },
      { id: '03', text: 'The Organising Committee of the Shenzhen International FinTech Competition reserves the right of final interpretation.' }
    ],
    place: '2026 Shenzhen International FinTech Competition',
    time: '2026'
  }
}
